import type { Address } from "../../../models";
import type { SchoolCandidateResidenceChange } from "../../../models/SchoolCandidate";

export type ResidenceCellPriority = "newAddressApproved" | "differentCounty";

function isFromDifferentCounty(
  currentAddress: Address | null | undefined,
  newAddress: Address | null | undefined
) {
  if (!currentAddress || !newAddress) {
    return false;
  }

  if (!!currentAddress.countyId && !!newAddress.countyId) {
    return currentAddress.countyId !== newAddress.countyId;
  }

  return (currentAddress.county ?? "") !== (newAddress.county ?? "");
}

function hasDifferentCounty(item: SchoolCandidateResidenceChange) {
  const currentResidence =
    item.currentTemporaryResidence ?? item.currentPermanentResidence;
  const newResidence = item.newTemporaryResidence ?? item.newPermanentResidence;

  return isFromDifferentCounty(currentResidence, newResidence);
}

/**
 * Returns the table cell className for school candidate residence columns.
 * Priority controls which condition wins when both apply:
 * - "newAddressApproved": different county (danger) > approved (success) > base
 * - "differentCounty": different county (danger) > approved (success) > base
 */
export function getSchoolCandidateResidenceCellClassName(
  item: SchoolCandidateResidenceChange,
  priority: ResidenceCellPriority
) {
  const ADDRESS_CELL_BASE_CLASS = "text-nowrap";
  const isDifferentCounty = hasDifferentCounty(item);

  if (isDifferentCounty) {
    return `${ADDRESS_CELL_BASE_CLASS} text-danger`;
  }

  if (priority === "newAddressApproved") {
    if (item.newAdressApproved) {
      return `${ADDRESS_CELL_BASE_CLASS} text-success`;
    }
  }

  return ADDRESS_CELL_BASE_CLASS;
}
